var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"change-password-container"},[_c('div',{staticClass:"card"},[_vm._m(0),_c('auth-set-pass',{on:{"changePass":_vm.changePass,"doNotShowModalAlert":_vm.doNotShowModalAlert}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card-header"},[_c('h3',[_vm._v("Change Password")])])
}]

export { render, staticRenderFns }